'use strict';
const angular = require('angular');

export class assetTagsComponent {
  /*@ngInject*/
  constructor(Config, StorageService) {
    this.StorageService = StorageService;
  }

  $onInit = function () {
    this.config = this.resolve.config;
    this.asset = this.config.asset;
  };

  ok() {

    this.StorageService.update({id: this.asset._id}, {
      tags: this.asset.tags
    }, () => {
      this.close({$value: 'ok'});
    });
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

}

export default angular.module('conduu.sm.asset.tags', [])
  .component('assetTags', {
    template: require('./asset-tags.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: assetTagsComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/~sm/components/asset/tags/asset-tags.component.js